export const faqCategories = [
  'All',
  'General IPTV',
  'Pricing',
  'Devices',
  'Streaming',
  'Trial',
  'Account & Subscription',
  'France',
  'Safety & Legal'
];

export const faqData = [
  {
    id: 1,
        category: 'General IPTV',

    question: "Comment fonctionne l'abonnement IPTV ?",
    answer:
      "Choisissez l'abonnement qui correspond à vos besoins et passez votre commande. Après confirmation du paiement, vous recevrez vos informations d'accès ainsi qu'un guide d'installation par e-mail."
  },

  {
    id: 2,
        category: 'Pricing',

    question: "Le prix de l'abonnement est-il mensuel ?",
    answer:
      "Non. Il s'agit d'un paiement unique pour la durée choisie. Aucun prélèvement mensuel automatique n'est effectué et votre abonnement ne se renouvelle pas automatiquement."
  },

  {
    id: 3,
        category: 'General IPTV',

    question: "Quand vais-je recevoir mes identifiants IPTV ?",
    answer:
      "Après la confirmation de votre paiement, vos informations d'accès sont généralement envoyées à l'adresse e-mail utilisée lors de la commande. Vérifiez également votre dossier spam ou courrier indésirable."
  },

  {
    id: 4,
        category: 'France',

    question: "Le service IPTV fonctionne-t-il en France ?",
    answer:
      "La disponibilité du service dépend de votre connexion Internet, de votre appareil et des contenus proposés par le fournisseur. Si vous êtes en France et disposez d'une connexion Internet stable, vous pouvez utiliser un service IPTV compatible avec votre appareil."
  },

  {
    id: 5,
        category: 'Account & Subscription',

    question: "Comment obtenir un abonnement IPTV en France ?",
    answer:
      "Pour obtenir un abonnement IPTV, consultez nos offres, choisissez la durée qui vous convient et suivez les étapes indiquées lors de la commande. Après confirmation du paiement, vous recevrez les informations nécessaires pour configurer votre accès."
  },

  {
    id: 6,
        category: 'Devices',

    question: "Puis-je utiliser l'IPTV sur plusieurs appareils ?",
    answer:
      "Cela dépend de la formule choisie. Certaines offres permettent d'utiliser le service sur plusieurs appareils ou de bénéficier de plusieurs connexions simultanées. Consultez les détails de chaque abonnement avant de commander."
  },

  {
    id: 7,
        category: 'Devices',

    question: "Quels appareils sont compatibles avec l'IPTV ?",
    answer:
      "La compatibilité dépend du service et de l'application utilisée. Les solutions IPTV peuvent généralement être utilisées sur Smart TV, Android TV, Fire TV Stick, smartphones Android, iPhone, iPad, ordinateurs Windows et Mac, ainsi que sur certains lecteurs multimédias."
  },

  {
    id: 8,
        category: 'Streaming',

    question: "Quelle connexion Internet faut-il pour utiliser l'IPTV ?",
    answer:
      "Une connexion Internet stable est recommandée. Pour une utilisation en HD, une connexion d'environ 10 Mbps peut être suffisante. Pour la 4K, une connexion plus rapide, généralement autour de 25 Mbps ou davantage, est recommandée."
  },

  {
    id: 9,
        category: 'Streaming',

    question: "Quelle application utiliser pour regarder l'IPTV ?",
    answer:
      "Le choix de l'application dépend de votre appareil. Des lecteurs comme TiviMate, VLC ou d'autres applications compatibles peuvent être utilisés selon votre système et le format fourni par votre service IPTV."
  },

  {
    id: 10,
        category: 'General IPTV',

    question: "L'abonnement IPTV se renouvelle-t-il automatiquement ?",
    answer:
      "Non, nos offres sont basées sur un paiement unique pour la durée sélectionnée. Aucun renouvellement automatique n'est effectué à la fin de la période d'abonnement."
  },

  {
    id: 11,
        category: 'General IPTV',

    question: "Que faire si je ne reçois pas mes informations de connexion ?",
    answer:
      "Commencez par vérifier votre boîte de réception ainsi que vos dossiers spam et courrier indésirable. Si vous ne trouvez toujours pas votre commande, contactez notre support avec les informations relatives à votre achat afin que nous puissions vous aider."
  },

  {
    id: 12,
        category: 'Safety & Legal',

    question: "L'IPTV est-il légal en France ?",
    answer:
      "La technologie IPTV est légale. En revanche, la légalité d'un service dépend notamment des droits de diffusion des chaînes, films, séries et autres contenus proposés. Nous vous recommandons de vérifier que le fournisseur dispose des autorisations nécessaires pour les contenus auxquels vous souhaitez accéder."
  }
];
